/** @module Enums */ /** typedoc */
// When adding KIND here, don't forget the 'TrackTypeEnum' from Falcor
var LibraryItemEnum;
(function (LibraryItemEnum) {
    LibraryItemEnum["stem"] = "stem";
    LibraryItemEnum["track"] = "track";
    LibraryItemEnum["video"] = "video";
    LibraryItemEnum["album"] = "album";
    LibraryItemEnum["videoTrack"] = "videoTrack";
})(LibraryItemEnum || (LibraryItemEnum = {}));

export { LibraryItemEnum };
